import { render, staticRenderFns } from "./modal-completion-detail.vue?vue&type=template&id=65737548&scoped=true"
import script from "./modal-completion-detail.vue?vue&type=script&lang=js"
export * from "./modal-completion-detail.vue?vue&type=script&lang=js"
import style0 from "./modal-completion-detail.vue?vue&type=style&index=0&id=65737548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65737548",
  null
  
)

export default component.exports